export default "__VITE_ASSET__8e47bf69__"